module.exports = __webpack_public_path__ + "static/img/js_3.fa199ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coretesc/js_3.png
// module id = cgE0
// module chunks = 1